import React, { useEffect, useState } from "react";
import { appGetHome } from "../../services/HomeService";
import { HOME_API_STALE_TIME } from "../../utils/Constant";
import Header from "../../components/Header/Header";

import "./Home.css";

import { useQuery } from "react-query";
import useMobileDevice from "../../hooks/useMobileDevice";
import MobileHome from "./MobileHome";
import DesktopHome from "./DesktopHome";
import {commonPageEventsFB} from "../../utils/PixelEvents/FacebookEvents";
import {GoogleCommonEvents} from "../../utils/PixelEvents/GoogleEvents";
// import { useDispatch } from "react-redux";
// import { addCartCount } from "../../store/actions/cartActions";

function Home() {
  const [elements, setElements] = useState([]);
  const { isMobile } = useMobileDevice();
  // const dispatch = useDispatch();

  const { isLoading, data } = useQuery(
    "homeData",
    () =>
      appGetHome().then((res) => {
        res = JSON.parse(res?.data);
        return res;
      }),
    {
      staleTime: HOME_API_STALE_TIME,
    }
  );

  useEffect(() => {
    // dispatch(addCartCount(data?.total_cart_items || 0));
    setElements(data?.elements || []);
    // handling error in try catch block
    try {
      commonPageEventsFB('Home');
    } catch (e) {
      console.log(e.message);
    }
    // handling error in try catch block
    try {
      GoogleCommonEvents('home');
    } catch (e) {
      console.log(e.message);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      {/* Header */}
      <Header
        mobileHeaderOptions={{
          menuIcon: true,
          wishlistIcon: true,
          darveysLargeTextIcon: true,
          searchIcon: true,
          shoppingBagIcon: true,
          backButtonIcon: false,
          pageHeadingShow: false,
          pageHeadingText: "",
          darveysSmallIcon: false,
          userAccountIcon: false,
        }}
      />

      {isMobile ? (
        <MobileHome isLoading={isLoading} elements={elements} />
      ) : (
        <DesktopHome isLoading={isLoading} elements={elements} />
      )}
    </>
  );
}

export default Home;
